import { Oval } from "react-loader-spinner";

export default function Loader({ color, height, width, message,center }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        margin:center?"144px":"0px"
      }}
    >
      <Oval
        height={height || 50}
        width={height || 50}
        color={color ? color : "white"}
        secondaryColor="#6c95c7"
        ariaLabel="loading"
        strokeWidth={4}
        strokeWidthSecondary={4}
      />
      {message && <div style={{ padding: "10px" }}>{message}</div>}
    </div>
  );
}
